import React from 'react';
import { PageView } from './home';

class Home extends React.Component{
  render() {
      return (
        <PageView />
      )
  }
};

export default Home;